import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2, Clock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) {
      setStatus("missing");
      return;
    }
    let attempts = 0;
    const timer = setInterval(async () => {
      attempts += 1;
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          clearInterval(timer);
        } else if (attempts >= 15) {
          setStatus("pending");
          clearInterval(timer);
        }
      } catch (e) {
        if (attempts >= 15) {
          setStatus("error");
          clearInterval(timer);
        }
      }
    }, 2000);
    return () => clearInterval(timer);
  }, [sessionId]);

  return (
    <div
      data-testid="payment-success-page"
      className="bg-linen text-ink font-sans min-h-screen flex items-center justify-center px-6"
    >
      <div className="bg-white border border-cream rounded-3xl shadow-xl p-10 max-w-md w-full text-center">
        {status === "checking" && (
          <>
            <Loader2 className="w-12 h-12 text-forest mx-auto mb-4 animate-spin" />
            <h1 className="font-display text-2xl text-ink mb-2">Confirming your payment…</h1>
            <p data-testid="payment-status" className="text-sm text-moss">
              Please hold on while we verify your booking with our payment provider.
            </p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="w-12 h-12 text-forest mx-auto mb-4" />
            <h1 className="font-display text-2xl text-ink mb-2">You're booked in.</h1>
            <p data-testid="payment-status" className="text-sm text-moss mb-8">
              Your course place is confirmed. Elisabete will be in touch shortly with your
              cohort dates, venue details and what to bring.
            </p>
          </>
        )}
        {(status === "pending" || status === "error" || status === "missing") && (
          <>
            <Clock className="w-12 h-12 text-forest mx-auto mb-4" />
            <h1 className="font-display text-2xl text-ink mb-2">Almost there.</h1>
            <p data-testid="payment-status" className="text-sm text-moss mb-8">
              Your payment is still being processed. If you were charged, your place is safe —
              call <a href="tel:+447479815308" className="text-forest underline">+44 7479 815308</a>{" "}
              and Elisabete will confirm your booking.
            </p>
          </>
        )}
        <Link
          data-testid="back-home-link"
          to="/"
          className="inline-block px-6 py-3 rounded-full bg-forest text-linen text-xs font-semibold uppercase tracking-widest hover:bg-ink transition-colors"
        >
          Back to Course Page
        </Link>
      </div>
    </div>
  );
}
